export const ACCIDENT_PARTICIPANT_TYPES = [
  {
    value: 'victim',
    label: 'claim.personalData.victim',
    onlyPhysical: true,
  },
  {
    value: 'applicant',
    label: 'claim.personalData.cascoApplicantType',
    onlyPhysical: false,
  },
  {
    value: 'other',
    label: 'claim.personalData.other',
    onlyPhysical: false,
  },
  {
    value: 'isParked',
    label: 'claim.personalData.isParked',
    onlyPhysical: false,
  },
];

export const ACCIDENT_OTHER_CARS_OPTIONS = [
  { value: false, label: 'claim.accInfo.no' },
  { value: true, label: 'claim.accInfo.yes' },
];

export const INSURED_TYPES = {
  physical: '1',
  legal: '2',
};

export default ACCIDENT_PARTICIPANT_TYPES;

export const PHYSICAL_APPLICANT_FIELDS = ['pnum', 'ssn', 'tpnum', 'policy'];
export const LEGAL_APPLICANT_FIELDS = ['hvhh', 'tpnum', 'policy'];

export const PHYSICAL_PERSONAL_INFORMATION_FIELDS = [
  'firstName',
  'lastName',
  'passportNum',
  'applicantIs',
  'isCitizen',
  'passportGivenDate',
  'passportValidUntilDate',
  'passportFrom',
  'transportManufacturer',
  'transportModel',
  'formLanguage',
  'applicantToVictim',
  'participantIs',
  'stateNumber',
  'vin',
];

export const LEGAL_PERSONAL_INFORMATION_FIELDS = [
  'applicantIs',
  'transportManufacturer',
  'transportModel',
  'formLanguage',
  'applicantCitizenship',
  'participantIs',
  'applicantGender',
  'stateNumber',
  'vin',
];

export const ACCIDENT_INFO_FIELDS = [
  'accidentDate',
  'accidentTime',
  'contract',
  'accCountry',
  'isAccInArmenia',
  'accState',
  'accVillage',
  'accStreet',

  'damageLevel',
  'isExistOtherCar',
  'carCountry',
  'isCarInArmenia',
  'carState',
  'carVillage',
  'carStreet',
  'vehicles',

  'damageAmount',
  'damagedParts',
  'accidentDetails',
  'proceedingStatus',
  'formLanguage',
];

export const CONCLUSION_STE_FIELDS = [
  'receivedCompensation',
  'receivedCompensationSum',
  'citizenship',
  'hasAgreed',
];

export const APPLICANT_RESIDENCE_ADDRESS_FIELDS = [
  'applicantResidenceCountry',
  'applicantResidenceState',
  'applicantResidenceCityVillage',
  'applicantResidenceStreet',
];
